// NOTE: this is some simple business logic to demonstrate how the page could work, but validation isn't included on the main pages in the stub

import {setElementsFromScope} from '../../utilities/selectorHelpers';
import timePicker from "../../components/timePicker/timePicker";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";

const elementsPageMap = {
  checkSched: ".check-pickup-sched",
  closeSched: ".close-pickup-sched",
  viewSchedCard: ".view-schedule-pickup",
  viewSchedConfirmation: ".confirm-schedule-pickup",
  schedPickupBtnFinal: ".sched-pickup-btn-final",
  findAvailabilityBtn: "#find-availability-btn",
  pickupAvailability: "#pickup-availability",
  schedulePickupForm:"#schedule-pickup-form",
  schedulePickupOptions: "#schedule-pickup-options",
  selectPicupAddressRadio: '.select-pickup-address',
  pickupAddressClosingTime: '#pickup-address-closing-time',
  pickupCutoffTime: '#pickup-cutoff-time',
  genericPgSelects: ".select2-select"
};

const customValidateProps = {
  errorPlacement: function(error, element) {
    let appendClosest = $(element).data('error-placement-append-closest');
    if (appendClosest) {
      $(element).closest(appendClosest).append(error);
    } else {
      error.insertAfter(element);
    }
  }
};

export default function SchedPickupDisplayLogic(mainEl, {isExternal=false}={}){
  const self = this;
  const elsPage = {};
  const closingTimePickerEl = mainEl.find('.time-picker-closing-time');

  let opts = {};
  if(isExternal){
    opts = { addSelect2Class : 'consumer'};
  }
  const closingTimePicker = timePicker(closingTimePickerEl, opts);
  closingTimePicker.setTimeFromMilitary("18:00");


  var submitModalFlow = new SubmitModalFlow({
   confirmModalTitle: 'Schedule Pick Up',
    // confirmModalSubtitle: "Optional Subtitle",
    confirmModalBody: '<div class="q-pad-all-xl">By confirming this scheduled pick up, you agree to leave your package(s) at the location within the time frame available on the date that is specified in this form.</div>',
    confirmModalBtnText: 'Confirm',
    onConfirmClick: function(){  
        schedPickupFinalHandle()
      }
    });
  submitModalFlow.init();

  self.init = function(){
    setElements();
    setInitialState();
    bindElements();
  };

  function setElements(){
    setElementsFromScope(elsPage, elementsPageMap, mainEl);
  };

  function setInitialState(){
    elsPage.viewSchedCard.hide();
    elsPage.viewSchedConfirmation.hide();
    elsPage.closeSched.hide();

    elsPage.schedulePickupForm.validate(customValidateProps);
  };

  function bindElements(){
    elsPage.checkSched.click(checkSchedClick);
    elsPage.closeSched.click(closeSchedClick);
    elsPage.schedPickupBtnFinal.click(schedPickupFinalClick);
    elsPage.findAvailabilityBtn.click(findAvailability);
    elsPage.selectPicupAddressRadio.click(updateSelectedPickupAddress1);
    // elsPage.genericPgSelects.change(validateIndividualSelects);
  };

  function updateSelectedPickupAddress1() {
    elsPage.pickupAvailability.hide();
    if(elsPage.selectPicupAddressRadio.val() == 'alternate') {
      $('#selected-pickup-address1').val($('.alt-address-st1').text());
      $('#selected-pickup-address2').val($('.alt-address-st2').text());
      $('#selected-pickup-city').val($('.alt-address-city').text());
      $('#selected-pickup-state').val($('.alt-address-state').text());
      $('#selected-pickup-zip').val($('.alt-address-zip').text());
      $('#selected-pickup-country').val("US");
    } else {
      $('#selected-pickup-address1').val($('.default-address-st1').text());
      $('#selected-pickup-address2').val($('.default-address-st2').text());
      $('#selected-pickup-city').val($('.default-address-city').text());
      $('#selected-pickup-state').val($('.default-address-state').text());
      $('#selected-pickup-zip').val($('.default-address-zip').text());
      $('#selected-pickup-country').val("US");
    }
  };

  // NOTE: not working correctly here, even though it works all right in modal validation. Look into this later
  function validateIndividualSelects() {
    $(this).valid();
  };

  function checkSchedClick(e) {
    e.preventDefault();

    if($(this).hasClass("disabled")){
      return;
    }

    checkSchedHandle();
  };

  function closeSchedClick(e) {
    e.preventDefault();

    closeSchedHandle();
  };

  function schedPickupFinalClick(e) {
    e.preventDefault();

   // schedPickupFinalHandle();
   submitModalFlow.showConfirmModal();
  };

  function findAvailability(e) {
    e.preventDefault();

    elsPage.pickupAvailability.hide();
    elsPage.pickupAddressClosingTime.val(closingTimePicker.getMilitaryTime() + ':00');

    const pickupDate = elsPage.schedulePickupForm.find(".date-of-pickup").val();

    if (elsPage.schedulePickupForm.valid()) {      
      $.ajax({
  			url: elsPage.findAvailabilityBtn.data("url") + "&pickupDate="+pickupDate,
  			type: 'POST',
  			dataType: 'html',
  			data: elsPage.schedulePickupForm.serialize(),
        beforeSend : function() {
        	//$.blockUI({message : 'Please Wait..'}); // TODO like previouslyShippedLoader.show();
          submitModalFlow.showLoadingModal();
        },
        complete : function() {
        	//$.unblockUI(); //TODO like previouslyShippedLoader.hide();

        },
        success: function(resp){
          	elsPage.pickupAvailability.html(resp);
            elsPage.pickupAvailability.show();
            $(".sched-pickup-btn-final").click(schedPickupFinalClick);
            submitModalFlow.hideAllModals();
  			},
  			error: function(xhr,status,error) {
          submitModalFlow.hideAllModals();
  			}
      });
    }
  };


  function checkSchedHandle() {
    elsPage.checkSched.hide();
    elsPage.closeSched.show();

    elsPage.viewSchedCard.slideDown();
  };

  function closeSchedHandle() {
    elsPage.checkSched.show();
    elsPage.closeSched.hide();

    elsPage.viewSchedCard.slideUp();
  };

  function schedPickupFinalHandle() {
    elsPage.pickupAddressClosingTime.val(closingTimePicker.getMilitaryTime() + ":00");
    elsPage.pickupCutoffTime.val($('input[name=pickupDate]:checked').closest('tr').find(".cutoff-time").text().trim());
    if (elsPage.schedulePickupForm.valid()) {
      $.ajax({
  			url: $(".sched-pickup-btn-final").data("url"),
  			type: 'POST',
  			dataType: 'html',
  			data: elsPage.schedulePickupForm.serialize(),
        beforeSend : function() {
        	//$.blockUI({message : 'Please Wait..'}); // TODO like previouslyShippedLoader.show();
          submitModalFlow.showLoadingModal();
        },
        complete : function() {
        	//$.unblockUI(); //TODO like previouslyShippedLoader.hide();
        },
        success: function(resp){
          	elsPage.viewSchedConfirmation.html(resp);
            $("#retry-schedule-pickup").click(retrySchedulePickup);
            //elsPage.viewSchedCard.slideUp(viewConfirmationSlideDown);
            elsPage.viewSchedConfirmation.slideDown();
            elsPage.schedulePickupOptions.hide();
            if(!resp.includes('Error')){
              submitModalFlow.showSuccessModal();
            }
            setTimeout(function() {
             submitModalFlow.hideAllModals(); 
            }, SUCCESS_MODAL_TIMEOUT);
  			},
  			error: function(xhr,status,error) {
           //TODO when error give the proper response
           submitModalFlow.hideAllModals();
  			}
      });
    }
  };


  function disableBtn(btn){
    btn.addClass("disabled");
  };

  //Putting this in separate function so event occurs at proper time
  function viewConfirmationSlideDown(){
    elsPage.viewSchedConfirmation.slideDown();
  };

  function retrySchedulePickup(){
    elsPage.schedulePickupOptions.show();
    elsPage.viewSchedConfirmation.hide();
    elsPage.pickupAvailability.show();
    elsPage.checkSched.hide();
    elsPage.closeSched.show();
  };
};



// WEBPACK FOOTER //
// ./src/pages/schedulePickup/viewSchedPickupDisplayLogic.js